import React from "react";
import Grid from '@mui/material/Grid2';
import { styled, CircularProgress, Typography } from "@mui/material";
import DeviceCard, {
  DeviceType,
} from "@common/components/ListDetailViews/DetailView/DeviceCard";
import { useTranslation } from "react-i18next";

export const ListContainer = styled(Grid)(({ theme }) => ({
  gap: theme.spacing(2),
  height: "100%",
  overflow: "auto",
  padding: theme.spacing(2, 0),
}));
export const DeviceCardList = ({
  loading = false,
  devices,
  previousLabel,
  showProvisionedOnly = true,
  isArchivedDevices = false,
}: {
  loading?: boolean;
  devices: DeviceType[];
  previousLabel: string;
  showProvisionedOnly?: boolean;
  isArchivedDevices?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <ListContainer
      container
      gap={2}
      sx={{ height: 1, overflow: "auto", py: 2 }}
    >
      {loading ? (
        <CircularProgress
          sx={{ position: "relative", top: "50%", left: "50%" }}
        />
      ) : (
        <Grid
          sx={{
            width: "100%"
          }}>
          {devices.length > 0 ? (
            <Grid
              sx={{
                gridTemplateColumns: "repeat(auto-fill, minmax(225px, 1fr))",
                display: "grid",
                gap: "1rem"
              }}>
              {devices.map((device) => (
                <Grid key={device.id}>
                  <DeviceCard
                    device={device}
                    previousPage={previousLabel}
                    isArchivedDevice={isArchivedDevices}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography sx={{
              width: "100%"
            }}>
              {isArchivedDevices
                ? t("There are no archived devices")
                : showProvisionedOnly
                ? t("There are no provisioned devices")
                : t("There are no unprovisioned devices")}
            </Typography>
          )}
        </Grid>
      )}
    </ListContainer>
  );
};

export default DeviceCardList;
